var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___OVlua1",
  "pG": "ChannelOverviewTab.module__regionEmoji___OVlua1",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___OVlua1",
  "c5": "ChannelOverviewTab.module__topicInput___OVlua1",
  "Z8": "ChannelOverviewTab.module__emojiButton___OVlua1",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___OVlua1",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___OVlua1",
  "p9": "ChannelOverviewTab.module__sectionWrapper___OVlua1",
  "h3": "ChannelOverviewTab.module__settingsGroup___OVlua1",
  "hB": "ChannelOverviewTab.module__settingsControlRow___OVlua1",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___OVlua1",
  "Y4": "ChannelOverviewTab.module__settingsControlText___OVlua1",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___OVlua1",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___OVlua1",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___OVlua1",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___OVlua1",
};

module.exports = exports;
